module.exports = __webpack_public_path__ + "media/images/icon-pin-8c127cd06d43c6e7eed2ffba47ae8636.svg";